// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   Envios del cliente: las tres modalidades en una columna.

   Reemplaza la columna "Loads", que traia solo terrestre y sin limite.
   ========================================================================== */
.ShipmentsColumn_col__Ncqsb {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 14px 15px 15px;
}

.ShipmentsColumn_head__US9bL {
  margin-bottom: 10px;
}
.ShipmentsColumn_title__XfyJl {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--dylo-text);
}
/* El total va en el titulo: es el dato que se busca al abrir la ficha, y con una
   lista paginada no se puede obtener contando renglones. */
.ShipmentsColumn_total__NTxRe {
  font-size: 11px;
  font-weight: 500;
  color: var(--dylo-muted);
  padding: 1px 7px;
  border: 1px solid var(--dylo-border);
  border-radius: 10px;
  font-variant-numeric: tabular-nums;
}

/* ------------------------------ Modalidades -------------------------------
   Solo aparecen si el cliente tiene mas de una. Un filtro que siempre devuelve
   vacio se lee como un fallo de la pantalla.
   ------------------------------------------------------------------------ */
.ShipmentsColumn_modes__04Gpl {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 9px;
}
.ShipmentsColumn_modeBtn__\\+9MFb {
  padding: 3px 9px;
  border: 1px solid var(--dylo-border);
  border-radius: 6px;
  background: transparent;
  color: var(--dylo-muted);
  font-size: 11px;
  cursor: pointer;
  font-variant-numeric: tabular-nums;
  transition: border-color 140ms ease, color 140ms ease, background 140ms ease;
}
.ShipmentsColumn_modeBtn__\\+9MFb:hover {
  color: var(--dylo-text);
}
.ShipmentsColumn_modeOn__25Pqx {
  color: var(--dylo-text);
  border-color: var(--dylo-accent, #4a9ee0);
  background: color-mix(in srgb, var(--dylo-accent, #4a9ee0) 12%, transparent);
}

.ShipmentsColumn_search__56k6T {
  margin-bottom: 10px;
}

/* --------------------------------- Lista ----------------------------------
   15-oct-2026: con tope de alto y la barra fina, como Users y Deliveries (\`.colList\` de ClientDetail.module.css). Sin
   tope, una pagina de 20 envios estiraba la columna muy por debajo de las otras dos y nunca salia la barra.
   ------------------------------------------------------------------------ */
.ShipmentsColumn_list__2TZXb {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  min-height: 0;
  max-height: calc(100vh - 290px);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;
}
.ShipmentsColumn_list__2TZXb::-webkit-scrollbar {
  width: 6px;
}
.ShipmentsColumn_list__2TZXb::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);
  border-radius: 3px;
}
.ShipmentsColumn_row__16Dth {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 9px;
  border: 1px solid transparent;
  border-radius: 6px;
  transition: background 120ms ease, border-color 120ms ease;
}
.ShipmentsColumn_clickable__953o9 {
  cursor: pointer;
}
.ShipmentsColumn_clickable__953o9:hover {
  border-color: var(--dylo-border);
  background: color-mix(in srgb, var(--dylo-muted) 8%, transparent);
}
.ShipmentsColumn_reference__mGndz {
  font-size: 12.5px;
  font-weight: 500;
  color: var(--dylo-text);
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ShipmentsColumn_meta__YT0aP {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  font-size: 11px;
  color: var(--dylo-muted);
  white-space: nowrap;
}
/* El estatus con el color de la tabla de cargas (15-oct-2026). El texto mezcla ese color con la tinta del tema para
   leerse en claro y en oscuro, como en la bandeja de avisos. */
.ShipmentsColumn_status__\\+rMMB {
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 600;
  color: color-mix(
    in srgb,
    var(--status-color, var(--dylo-muted)) var(--dylo-tint-text, 70%),
    var(--dylo-ink)
  );
  background: color-mix(in srgb, var(--status-color, var(--dylo-muted)) 13%, transparent);
  border: 1px solid color-mix(in srgb, var(--status-color, var(--dylo-muted)) 34%, transparent);
}
.ShipmentsColumn_when__HwPns {
  font-variant-numeric: tabular-nums;
}

/* ------------------------------ La insignia -------------------------------
   LETRAS y color, no solo color: un badge que solo se distingue por tono deja
   fuera a quien no separa bien los colores, y se pierde en una captura en
   blanco y negro -- que es como se comparten estos casos cuando algo no cuadra.
   ------------------------------------------------------------------------ */
.ShipmentsColumn_tag__Hxs15 {
  flex-shrink: 0;
  width: 34px;
  text-align: center;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 2px 0;
  border-radius: 4px;
}
.ShipmentsColumn_tag_land__cb9Qr {
  color: #b58a3c;
  background: color-mix(in srgb, #b58a3c 14%, transparent);
  border: 1px solid color-mix(in srgb, #b58a3c 34%, transparent);
}
.ShipmentsColumn_tag_ocean__KYuwV {
  color: #3c7fb5;
  background: color-mix(in srgb, #3c7fb5 14%, transparent);
  border: 1px solid color-mix(in srgb, #3c7fb5 34%, transparent);
}
.ShipmentsColumn_tag_air__gADhU {
  color: #7d5cb5;
  background: color-mix(in srgb, #7d5cb5 14%, transparent);
  border: 1px solid color-mix(in srgb, #7d5cb5 34%, transparent);
}
.ShipmentsColumn_mode_land__A9DXg.ShipmentsColumn_modeOn__25Pqx {
  border-color: color-mix(in srgb, #b58a3c 55%, transparent);
  background: color-mix(in srgb, #b58a3c 12%, transparent);
}
.ShipmentsColumn_mode_ocean__m8zI7.ShipmentsColumn_modeOn__25Pqx {
  border-color: color-mix(in srgb, #3c7fb5 55%, transparent);
  background: color-mix(in srgb, #3c7fb5 12%, transparent);
}
.ShipmentsColumn_mode_air__WJjhT.ShipmentsColumn_modeOn__25Pqx {
  border-color: color-mix(in srgb, #7d5cb5 55%, transparent);
  background: color-mix(in srgb, #7d5cb5 12%, transparent);
}

.ShipmentsColumn_empty__m7Hc7 {
  margin: 8px 0 0;
  font-size: 12px;
  color: var(--dylo-muted);
}

/* Terrestre oculto: el cliente no esta asignado a quien mira (punto 10, 13-oct-2026) */
.ShipmentsColumn_hiddenNote__W5lG8 {
  margin: 0 0 10px;
  padding: 7px 10px;
  border: 1px dashed var(--dylo-line);
  border-radius: 8px;
  font-size: 12px;
  color: var(--dylo-muted);
}

/* -------------------------------- Paginado --------------------------------
   Anterior / siguiente, SIN numeros de pagina: con busqueda no hay total exacto
   -contarlo exigiria el mismo LIKE en las tres tablas- y "pagina 3 de 74" con
   un total inventado es peor que no pintarlo.
   ------------------------------------------------------------------------ */
.ShipmentsColumn_pager__saRyE {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
  padding-top: 9px;
  border-top: 1px solid var(--dylo-border);
}
.ShipmentsColumn_pagerBtn__3SYiS {
  padding: 3px 10px;
  border: 1px solid var(--dylo-border);
  border-radius: 6px;
  background: transparent;
  color: var(--dylo-text);
  font-size: 11.5px;
  cursor: pointer;
}
.ShipmentsColumn_pagerBtn__3SYiS:hover:not(:disabled) {
  border-color: var(--dylo-accent, #4a9ee0);
}
.ShipmentsColumn_pagerBtn__3SYiS:disabled {
  opacity: 0.4;
  cursor: default;
}
.ShipmentsColumn_pagerAt__PqT-X {
  font-size: 11px;
  color: var(--dylo-muted);
  font-variant-numeric: tabular-nums;
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/ClientDetail/components/ShipmentsColumn.module.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;2DAC2D;AAC3D;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;;6EAG6E;AAC7E;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,4EAA4E;AAC9E;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;6EAG6E;AAC7E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,mFAAmF;AACrF;AACA;EACE,UAAU;AACZ;AACA;EACE,kEAAkE;EAClE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,0DAA0D;AAC5D;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,iEAAiE;AACnE;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;AACA;+DAC+D;AAC/D;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB;;;;GAIC;EACD,uFAAuF;EACvF,6FAA6F;AAC/F;AACA;EACE,kCAAkC;AACpC;;AAEA;;;;6EAI6E;AAC7E;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,wDAAwD;EACxD,8DAA8D;AAChE;AACA;EACE,cAAc;EACd,wDAAwD;EACxD,8DAA8D;AAChE;AACA;EACE,cAAc;EACd,wDAAwD;EACxD,8DAA8D;AAChE;AACA;EACE,0DAA0D;EAC1D,wDAAwD;AAC1D;AACA;EACE,0DAA0D;EAC1D,wDAAwD;AAC1D;AACA;EACE,0DAA0D;EAC1D,wDAAwD;AAC1D;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA,uFAAuF;AACvF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;;;6EAI6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,kCAAkC;AACpC","sourcesContent":["/* =============================================================================\n   Envios del cliente: las tres modalidades en una columna.\n\n   Reemplaza la columna \"Loads\", que traia solo terrestre y sin limite.\n   ========================================================================== */\n.col {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  padding: 14px 15px 15px;\n}\n\n.head {\n  margin-bottom: 10px;\n}\n.title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--dylo-text);\n}\n/* El total va en el titulo: es el dato que se busca al abrir la ficha, y con una\n   lista paginada no se puede obtener contando renglones. */\n.total {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--dylo-muted);\n  padding: 1px 7px;\n  border: 1px solid var(--dylo-border);\n  border-radius: 10px;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ------------------------------ Modalidades -------------------------------\n   Solo aparecen si el cliente tiene mas de una. Un filtro que siempre devuelve\n   vacio se lee como un fallo de la pantalla.\n   ------------------------------------------------------------------------ */\n.modes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin-bottom: 9px;\n}\n.modeBtn {\n  padding: 3px 9px;\n  border: 1px solid var(--dylo-border);\n  border-radius: 6px;\n  background: transparent;\n  color: var(--dylo-muted);\n  font-size: 11px;\n  cursor: pointer;\n  font-variant-numeric: tabular-nums;\n  transition: border-color 140ms ease, color 140ms ease, background 140ms ease;\n}\n.modeBtn:hover {\n  color: var(--dylo-text);\n}\n.modeOn {\n  color: var(--dylo-text);\n  border-color: var(--dylo-accent, #4a9ee0);\n  background: color-mix(in srgb, var(--dylo-accent, #4a9ee0) 12%, transparent);\n}\n\n.search {\n  margin-bottom: 10px;\n}\n\n/* --------------------------------- Lista ----------------------------------\n   15-oct-2026: con tope de alto y la barra fina, como Users y Deliveries (`.colList` de ClientDetail.module.css). Sin\n   tope, una pagina de 20 envios estiraba la columna muy por debajo de las otras dos y nunca salia la barra.\n   ------------------------------------------------------------------------ */\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-height: 0;\n  max-height: calc(100vh - 290px);\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;\n}\n.list::-webkit-scrollbar {\n  width: 6px;\n}\n.list::-webkit-scrollbar-thumb {\n  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);\n  border-radius: 3px;\n}\n.row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 9px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  transition: background 120ms ease, border-color 120ms ease;\n}\n.clickable {\n  cursor: pointer;\n}\n.clickable:hover {\n  border-color: var(--dylo-border);\n  background: color-mix(in srgb, var(--dylo-muted) 8%, transparent);\n}\n.reference {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: var(--dylo-text);\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  font-size: 11px;\n  color: var(--dylo-muted);\n  white-space: nowrap;\n}\n/* El estatus con el color de la tabla de cargas (15-oct-2026). El texto mezcla ese color con la tinta del tema para\n   leerse en claro y en oscuro, como en la bandeja de avisos. */\n.status {\n  padding: 1px 8px;\n  border-radius: 999px;\n  font-size: 10.5px;\n  font-weight: 600;\n  color: color-mix(\n    in srgb,\n    var(--status-color, var(--dylo-muted)) var(--dylo-tint-text, 70%),\n    var(--dylo-ink)\n  );\n  background: color-mix(in srgb, var(--status-color, var(--dylo-muted)) 13%, transparent);\n  border: 1px solid color-mix(in srgb, var(--status-color, var(--dylo-muted)) 34%, transparent);\n}\n.when {\n  font-variant-numeric: tabular-nums;\n}\n\n/* ------------------------------ La insignia -------------------------------\n   LETRAS y color, no solo color: un badge que solo se distingue por tono deja\n   fuera a quien no separa bien los colores, y se pierde en una captura en\n   blanco y negro -- que es como se comparten estos casos cuando algo no cuadra.\n   ------------------------------------------------------------------------ */\n.tag {\n  flex-shrink: 0;\n  width: 34px;\n  text-align: center;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  padding: 2px 0;\n  border-radius: 4px;\n}\n.tag_land {\n  color: #b58a3c;\n  background: color-mix(in srgb, #b58a3c 14%, transparent);\n  border: 1px solid color-mix(in srgb, #b58a3c 34%, transparent);\n}\n.tag_ocean {\n  color: #3c7fb5;\n  background: color-mix(in srgb, #3c7fb5 14%, transparent);\n  border: 1px solid color-mix(in srgb, #3c7fb5 34%, transparent);\n}\n.tag_air {\n  color: #7d5cb5;\n  background: color-mix(in srgb, #7d5cb5 14%, transparent);\n  border: 1px solid color-mix(in srgb, #7d5cb5 34%, transparent);\n}\n.mode_land.modeOn {\n  border-color: color-mix(in srgb, #b58a3c 55%, transparent);\n  background: color-mix(in srgb, #b58a3c 12%, transparent);\n}\n.mode_ocean.modeOn {\n  border-color: color-mix(in srgb, #3c7fb5 55%, transparent);\n  background: color-mix(in srgb, #3c7fb5 12%, transparent);\n}\n.mode_air.modeOn {\n  border-color: color-mix(in srgb, #7d5cb5 55%, transparent);\n  background: color-mix(in srgb, #7d5cb5 12%, transparent);\n}\n\n.empty {\n  margin: 8px 0 0;\n  font-size: 12px;\n  color: var(--dylo-muted);\n}\n\n/* Terrestre oculto: el cliente no esta asignado a quien mira (punto 10, 13-oct-2026) */\n.hiddenNote {\n  margin: 0 0 10px;\n  padding: 7px 10px;\n  border: 1px dashed var(--dylo-line);\n  border-radius: 8px;\n  font-size: 12px;\n  color: var(--dylo-muted);\n}\n\n/* -------------------------------- Paginado --------------------------------\n   Anterior / siguiente, SIN numeros de pagina: con busqueda no hay total exacto\n   -contarlo exigiria el mismo LIKE en las tres tablas- y \"pagina 3 de 74\" con\n   un total inventado es peor que no pintarlo.\n   ------------------------------------------------------------------------ */\n.pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 10px;\n  padding-top: 9px;\n  border-top: 1px solid var(--dylo-border);\n}\n.pagerBtn {\n  padding: 3px 10px;\n  border: 1px solid var(--dylo-border);\n  border-radius: 6px;\n  background: transparent;\n  color: var(--dylo-text);\n  font-size: 11.5px;\n  cursor: pointer;\n}\n.pagerBtn:hover:not(:disabled) {\n  border-color: var(--dylo-accent, #4a9ee0);\n}\n.pagerBtn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n.pagerAt {\n  font-size: 11px;\n  color: var(--dylo-muted);\n  font-variant-numeric: tabular-nums;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"col": `ShipmentsColumn_col__Ncqsb`,
	"head": `ShipmentsColumn_head__US9bL`,
	"title": `ShipmentsColumn_title__XfyJl`,
	"total": `ShipmentsColumn_total__NTxRe`,
	"modes": `ShipmentsColumn_modes__04Gpl`,
	"modeBtn": `ShipmentsColumn_modeBtn__+9MFb`,
	"modeOn": `ShipmentsColumn_modeOn__25Pqx`,
	"search": `ShipmentsColumn_search__56k6T`,
	"list": `ShipmentsColumn_list__2TZXb`,
	"row": `ShipmentsColumn_row__16Dth`,
	"clickable": `ShipmentsColumn_clickable__953o9`,
	"reference": `ShipmentsColumn_reference__mGndz`,
	"meta": `ShipmentsColumn_meta__YT0aP`,
	"status": `ShipmentsColumn_status__+rMMB`,
	"when": `ShipmentsColumn_when__HwPns`,
	"tag": `ShipmentsColumn_tag__Hxs15`,
	"tag_land": `ShipmentsColumn_tag_land__cb9Qr`,
	"tag_ocean": `ShipmentsColumn_tag_ocean__KYuwV`,
	"tag_air": `ShipmentsColumn_tag_air__gADhU`,
	"mode_land": `ShipmentsColumn_mode_land__A9DXg`,
	"mode_ocean": `ShipmentsColumn_mode_ocean__m8zI7`,
	"mode_air": `ShipmentsColumn_mode_air__WJjhT`,
	"empty": `ShipmentsColumn_empty__m7Hc7`,
	"hiddenNote": `ShipmentsColumn_hiddenNote__W5lG8`,
	"pager": `ShipmentsColumn_pager__saRyE`,
	"pagerBtn": `ShipmentsColumn_pagerBtn__3SYiS`,
	"pagerAt": `ShipmentsColumn_pagerAt__PqT-X`
};
export default ___CSS_LOADER_EXPORT___;
